<template>
    <div>
        <!-- Info Banner -->
        <div class="form-info-banner">
            <h3 class="form-info-banner-title">Os campos com * são de preenchimento obrigatório</h3>
            <p class="form-info-banner-text">Caso queira, você poderá salvar e continuar depois.</p>
        </div>

        <!-- Seção: Conta Principal -->
        <section class="form-section">
            <div class="form-section-header">
                
                <LabelDisclaimer :TamanhoFonteLabel="'H5'" :NomeLabel="'Conta principal'" 
                    :TipoCliente="tipoCliente" :Sessao="'Dados Bancários'" :SubSessao="'Conta Principal'"/>
                <p v-if="configTipo.multiplasContas" class="text-sm text-gray-600 dark:text-gray-400 mt-2">
                    Ao menos uma conta deverá ser informada. Caso queira, poderá adicionar mais contas.
                </p>
            </div>
            <div class="form-section-content">
                <div class="form-subsection">

                    <div class="form-grid-1">
                        <div class="form-field">
                            <label class="form-field-label form-field-label-required" for="bancoContaPrincipal">Banco</label>
                            <select id="bancoContaPrincipal" @change="salvarAlteracoesLocalmente" class="field" v-model="dadosBancariosContaPrincipal.NomeBanco">
                                <option value="">Selecione</option>
                                <option v-for="item in listaBancos" :key="item.Codigo" :value="item.Codigo">
                                    {{ item.Codigo + ' - ' + item.Descricao }}
                                </option>
                            </select>
                            <p v-if="camposObrigatorios.erroBanco" class="form-field-error">
                                Campo obrigatório.
                            </p>
                        </div>
                    </div>

                    <!-- Tipo de Conta (apenas PF) -->
                    <div v-if="configTipo.temTipoConta" class="form-grid-1">
                        <div class="form-field">
                            <label class="form-field-label form-field-label-required">Tipo de conta</label>
                            <select @change="salvarAlteracoesLocalmente" v-model="dadosBancariosContaPrincipal.TipoConta" class="field">
                                <option value="Conta Corrente">Conta Corrente</option>
                                <option value="Conta Poupança">Conta Poupança</option>
                            </select>
                        </div>
                    </div>

                    <div class="form-grid-4">
                        <div class="form-field">
                            <label class="form-field-label form-field-label-required" for="agenciaPrincipal">Agência</label>
                            <input class="field" type="text" @change="salvarAlteracoesLocalmente" v-model="dadosBancariosContaPrincipal.Agencia" id="agenciaPrincipal" placeholder="">
                            <p v-if="camposObrigatorios.erroAgencia" class="form-field-error">
                                Campo obrigatório.
                            </p>
                        </div>
                        <div class="form-field">
                            <label class="form-field-label" for="agenciaDigitoPrincipal">Dígito</label>
                            <input class="field" type="text" @change="salvarAlteracoesLocalmente" v-model="dadosBancariosContaPrincipal[configTipo.nomesCampos.agenciaDigito]" id="agenciaDigitoPrincipal" placeholder="">
                        </div>
                        <div class="form-field">
                            <label class="form-field-label form-field-label-required" for="contaCorrentePrincipal">Conta</label>
                            <input class="field" type="text" @change="salvarAlteracoesLocalmente" v-model="dadosBancariosContaPrincipal.ContaCorrente" id="contaCorrentePrincipal" placeholder="">
                            <p v-if="camposObrigatorios.erroContaCorrente" class="form-field-error">
                                Campo obrigatório.
                            </p>
                        </div>
                        <div class="form-field">
                            <label class="form-field-label form-field-label-required" for="contaCorrenteDigitoPrincipal">Dígito</label>
                            <input class="field" type="text" @change="salvarAlteracoesLocalmente" v-model="dadosBancariosContaPrincipal[configTipo.nomesCampos.contaDigito]" id="contaCorrenteDigitoPrincipal" placeholder="">
                            <p v-if="camposObrigatorios.erroContaCorrenteDigito" class="form-field-error">
                                Campo obrigatório.
                            </p>
                        </div>
                    </div>

                    <!-- Conta Conjunta (apenas PF) -->
                    <div v-if="configTipo.contaConjunta" class="form-grid-1 mt-4">
                        <div class="form-field">
                            <div class="flex gap-4 items-center">
                                <div class="flex items-center">
                                    <input type="checkbox" class="mr-2" id="contaPrincipalCheck" v-model="dadosBancariosContaPrincipal.Principal" disabled />
                                    <label class="mb-0" for="contaPrincipalCheck">Conta principal</label>
                                </div>
                                <div class="flex items-center">
                                    <input type="checkbox" class="mr-2" id="contaConjuntaCheck" v-model="dadosBancariosContaPrincipal.ContaConjunta" @change="salvarAlteracoesLocalmente" />
                                    <label class="mb-0" for="contaConjuntaCheck">Conta conjunta</label>
                                </div>
                                <div v-if="dadosBancariosContaPrincipal.ContaConjunta" class="flex items-center">
                                    <input type="checkbox" class="mr-2" id="titularCheck" v-model="Titular" @change="salvarAlteracoesLocalmente" />
                                    <label class="mb-0" for="titularCheck">Titular</label>
                                </div>
                                <div v-if="dadosBancariosContaPrincipal.ContaConjunta" class="flex items-center">
                                    <input type="checkbox" class="mr-2" id="cotitularCheck" v-model="Cotitular" @change="salvarAlteracoesLocalmente" />
                                    <label class="mb-0" for="cotitularCheck">Cotitular</label>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div v-if="configTipo.contaConjunta && dadosBancariosContaPrincipal.ContaConjunta" class="form-grid-2 mt-2">
                        <div class="form-field">
                            <label class="form-field-label">Nome completo</label>
                            <input class="field" @change="salvarAlteracoesLocalmente" type="text" v-model="dadosBancariosContaPrincipal.NomeCompleto" placeholder="">
                        </div>
                        <div class="form-field">
                            <label class="form-field-label">CPF</label>
                            <input class="field" @change="salvarAlteracoesLocalmente" v-mask="'###.###.###-##'" v-model="dadosBancariosContaPrincipal.CpfContaConjunta" type="text" placeholder="">
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!-- Botão Adicionar (apenas PF com múltiplas contas) -->
        <div v-if="configTipo.multiplasContas && contas.length == 0" class="flex justify-end mt-4">
            <button class="btn-secondary" @click="addContaBancaria">
                <i class="fa fa-plus mr-2"></i>
                Adicionar nova conta
            </button>
        </div>

        <!-- Contas Adicionais - PF (múltiplas dinâmicas) -->
        <section v-if="configTipo.multiplasContas && contas.length > 0" class="form-section mt-4">
            <div class="form-section-header">
                <h3 class="text-lg font-semibold text-gray-900 dark:text-gray-100">Conta adicional</h3>
            </div>
            <div class="form-section-content">
                <div v-for="(conta, index) in contas" :key="conta.Guid || index" class="form-subsection mb-6 pb-6 border-b border-gray-200 dark:border-gray-700">
                    <div class="flex justify-between items-center mb-4">
                        <h4 class="form-subsection-title mb-0">
                            <i class="fa fa-university"></i>
                            Conta {{ index + 2 }}
                        </h4>
                        <button @click="excluirContaBancaria(index)" class="text-red-600 hover:text-red-900 dark:text-red-400" title="Excluir conta">
                            <i class="fa fa-trash"></i>
                        </button>
                    </div>

                    <div class="form-grid-1">
                        <div class="form-field">
                            <label class="form-field-label form-field-label-required">Banco</label>
                            <select @change="salvarAlteracoesLocalmente" class="field" v-model="conta.NomeBanco">
                                <option value="">Selecione</option>
                                <option v-for="item in listaBancos" :key="item.Codigo" :value="item.Codigo">
                                    {{ item.Codigo + ' - ' + item.Descricao }}
                                </option>
                            </select>
                        </div>
                    </div>

                    <div v-if="configTipo.temTipoConta" class="form-grid-1">
                        <div class="form-field">
                            <label class="form-field-label form-field-label-required">Tipo de conta</label>
                            <select @change="salvarAlteracoesLocalmente" v-model="conta.TipoConta" class="field">
                                <option value="Conta Corrente">Conta Corrente</option>
                                <option value="Conta Poupança">Conta Poupança</option>
                            </select>
                        </div>
                    </div>

                    <div class="form-grid-4">
                        <div class="form-field">
                            <label class="form-field-label form-field-label-required">Agência</label>
                            <input class="field" @change="salvarAlteracoesLocalmente" type="text" v-model="conta.Agencia" placeholder="">
                        </div>
                        <div class="form-field">
                            <label class="form-field-label">Dígito</label>
                            <input class="field" @change="salvarAlteracoesLocalmente" v-model="conta[configTipo.nomesCampos.agenciaDigito]" type="text" placeholder="">
                        </div>
                        <div class="form-field">
                            <label class="form-field-label form-field-label-required">Conta</label>
                            <input class="field" @change="salvarAlteracoesLocalmente" v-model="conta.ContaCorrente" type="text" placeholder="">
                        </div>
                        <div class="form-field">
                            <label class="form-field-label form-field-label-required">Dígito</label>
                            <input class="field" @change="salvarAlteracoesLocalmente" v-model="conta[configTipo.nomesCampos.contaDigito]" type="text" placeholder="">
                        </div>
                    </div>

                    <div v-if="configTipo.contaConjunta" class="form-grid-1 mt-4">
                        <div class="form-field">
                            <div class="flex gap-4 items-center">
                                <div class="flex items-center">
                                    <input type="checkbox" class="mr-2" v-model="conta.Principal" disabled />
                                    <label class="mb-0">Conta principal</label>
                                </div>
                                <div class="flex items-center">
                                    <input type="checkbox" class="mr-2" v-model="conta.ContaConjunta" @change="salvarAlteracoesLocalmente" />
                                    <label class="mb-0">Conta conjunta</label>
                                </div>
                                <div v-if="conta.ContaConjunta" class="flex items-center">
                                    <input type="checkbox" class="mr-2" :checked="conta.TipoContaConjunta == 1" @click="updateTipoContaConjunta('titular', index, $event)" />
                                    <label class="mb-0">Titular</label>
                                </div>
                                <div v-if="conta.ContaConjunta" class="flex items-center">
                                    <input type="checkbox" class="mr-2" :checked="conta.TipoContaConjunta == 2" @click="updateTipoContaConjunta('cotitular', index, $event)" />
                                    <label class="mb-0">Cotitular</label>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div v-if="configTipo.contaConjunta && conta.ContaConjunta" class="form-grid-2 mt-2">
                        <div class="form-field">
                            <label class="form-field-label">Nome completo</label>
                            <input class="field" @change="salvarAlteracoesLocalmente" type="text" v-model="conta.NomeCompleto" placeholder="">
                        </div>
                        <div class="form-field">
                            <label class="form-field-label">CPF</label>
                            <input class="field" @change="salvarAlteracoesLocalmente" v-mask="'###.###.###-##'" v-model="conta.CpfContaConjunta" type="text" placeholder="">
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <div v-if="configTipo.multiplasContas && contas.length > 0" class="flex justify-end mt-4">
            <button class="btn-secondary" @click="addContaBancaria">
                <i class="fa fa-plus mr-2"></i>
                Adicionar nova conta
            </button>
        </div>

        <!-- Conta Adicional - PJ/FI (1 fixa) -->
        <section v-if="configTipo.contaAdicionalFixa" class="form-section mt-4">
            <div class="form-section-header">
                <LabelDisclaimer :TamanhoFonteLabel="'H5'" :NomeLabel="'Conta adicional'" 
                    :TipoCliente="tipoCliente" :Sessao="'Dados Bancários'" :SubSessao="'Conta Adicional'"/>
            </div>
            <div class="form-section-content">
                <div class="form-subsection">

                    <div class="form-grid-1">
                        <div class="form-field">
                            <label class="form-field-label" for="bancoContaAdicional">Banco</label>
                            <select id="bancoContaAdicional" @change="salvarAlteracoesLocalmenteAdicional" class="field" v-model="dadosBancariosContaAdicional.NomeBanco">
                                <option value="">Selecione</option>
                                <option v-for="item in listaBancos" :key="item.Codigo" :value="item.Codigo">
                                    {{ item.Codigo + ' - ' + item.Descricao }}
                                </option>
                            </select>
                            <p v-if="camposObrigatorios.erroNomeBancoAdicional" class="form-field-error">
                                Campo obrigatório.
                            </p>
                        </div>
                    </div>

                    <div class="form-grid-4">
                        <div class="form-field">
                            <label class="form-field-label" for="agenciaAdicional">Agência</label>
                            <input class="field" type="text" @change="salvarAlteracoesLocalmenteAdicional" v-model="dadosBancariosContaAdicional.Agencia" id="agenciaAdicional" placeholder="">
                            <p v-if="camposObrigatorios.erroAgenciaAdicional" class="form-field-error">
                                Campo obrigatório.
                            </p>
                        </div>
                        <div class="form-field">
                            <label class="form-field-label" for="agenciaDigitoAdicional">Dígito</label>
                            <input class="field" type="text" @change="salvarAlteracoesLocalmenteAdicional" v-model="dadosBancariosContaAdicional[configTipo.nomesCampos.agenciaDigito]" id="agenciaDigitoAdicional" placeholder="">
                        </div>
                        <div class="form-field">
                            <label class="form-field-label" for="contaCorrenteAdicional">Conta</label>
                            <input class="field" type="text" @change="salvarAlteracoesLocalmenteAdicional" v-model="dadosBancariosContaAdicional.ContaCorrente" id="contaCorrenteAdicional" placeholder="">
                            <p v-if="camposObrigatorios.erroContaCorrenteAdicional" class="form-field-error">
                                Campo obrigatório.
                            </p>
                        </div>
                        <div class="form-field">
                            <label class="form-field-label" for="contaCorrenteDigitoAdicional">Dígito</label>
                            <input class="field" type="text" @change="salvarAlteracoesLocalmenteAdicional" v-model="dadosBancariosContaAdicional[configTipo.nomesCampos.contaDigito]" id="contaCorrenteDigitoAdicional" placeholder="">
                            <p v-if="camposObrigatorios.erroDigitoContaCorrenteAdicional" class="form-field-error">
                                Campo obrigatório.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <ModalAlerta :mostrar="modalAlerta.mostrar" :tipo="modalAlerta.tipo" :titulo="modalAlerta.titulo" :mensagem="modalAlerta.mensagem" @fechar="modalAlerta.mostrar = false" />
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import api from '@/api/axios';
import LabelDisclaimer from '@/components/LabelDisclaimer.vue';
import ModalAlerta from '../Utilitarios/ModalAlerta.vue';

export default {
    name: 'DadosBancariosShared',
    components: { LabelDisclaimer, ModalAlerta },
    props: {
        tipoCliente: {
            type: String,
            required: true,
            validator: (value) => ['Pessoa Física', 'Pessoa Jurídica', 'Fundos'].includes(value)
        },
        Edicao: Boolean
    },
    computed: {
        ...mapGetters({
            listaBancos: 'GET_LISTA_BANCOS'
        }),

        infoBancariosPorTipo() {
            const getters = {
                'Pessoa Física': 'GET_PF_INFO_BANCARIOS',
                'Pessoa Jurídica': 'GET_PJ_INFO_BANCARIOS',
                'Fundos': 'GET_FI_INFO_BANCARIO'
            };
            return this.$store.getters[getters[this.tipoCliente]] || [];
        },

        configTipo() {
            return {
                'Pessoa Física': {
                    multiplasContas: true,
                    contaConjunta: true,
                    temTipoConta: true,
                    contaAdicionalFixa: false,
                    nomesCampos: {
                        agenciaDigito: 'AgenciaDigito',
                        contaDigito: 'ContaCorrenteDigito'
                    },
                    storeMutation: 'SET_PF_SALVAR_INFO_BANCARIAS',
                    estruturaDados: 'array',
                    apiExclusao: true,
                    proximaEtapa: 4
                },
                'Pessoa Jurídica': {
                    multiplasContas: false,
                    contaConjunta: false,
                    temTipoConta: false,
                    contaAdicionalFixa: true,
                    nomesCampos: {
                        agenciaDigito: 'DigitoAgencia',
                        contaDigito: 'DigitoContaCorrente'
                    },
                    storeMutation: 'SET_PJ_SALVAR_INFO_BANCARIAS',
                    storeMutationAdicional: 'SET_PJ_SALVAR_INFO_BANCARIAS_ADICIONAL',
                    estruturaDados: 'objetos',
                    apiExclusao: false,
                    proximaEtapa: 5
                },
                'Fundos': {
                    multiplasContas: false,
                    contaConjunta: false,
                    temTipoConta: false,
                    contaAdicionalFixa: true,
                    nomesCampos: {
                        agenciaDigito: 'DigitoAgencia',
                        contaDigito: 'DigitoContaCorrente'
                    },
                    storeMutation: 'SET_FI_SALVAR_INFO_BANCARIO',
                    storeMutationAdicional: 'SET_FI_SALVAR_INFO_BANCARIO_ADICIONAL',
                    estruturaDados: 'objetos',
                    apiExclusao: false,
                    proximaEtapa: 5
                }
            }[this.tipoCliente];
        }
    },
    data() {
        return {
            modalAlerta: { mostrar: false, tipo: 'warning', titulo: '', mensagem: '' },
            permitirAvancar: false,
            Titular: false,
            Cotitular: false,
            contas: [],
            camposObrigatorios: {
                erroContaCorrenteDigito: false,
                erroContaCorrente: false,
                erroAgencia: false,
                erroBanco: false,
                erroNomeBancoAdicional: false,
                erroAgenciaAdicional: false,
                erroContaCorrenteAdicional: false,
                erroDigitoContaCorrenteAdicional: false
            },
            dadosBancariosContaPrincipal: {},
            dadosBancariosContaAdicional: {}
        };
    },
    created() {
        // Inicializar estruturas de dados
        this.dadosBancariosContaPrincipal = this.initContaPrincipal();
        this.dadosBancariosContaAdicional = this.initContaAdicional();
        
        if (this.infoBancariosPorTipo.length > 0) {
            if (this.configTipo.estruturaDados === 'array') {
                // PF: array
                const contaPrincipal = this.infoBancariosPorTipo.find(conta => conta.Principal === true);
                if (contaPrincipal) {
                    this.dadosBancariosContaPrincipal = contaPrincipal;
                    this.contas = this.infoBancariosPorTipo.filter(conta => conta.Principal === false);
                }
                if (this.dadosBancariosContaPrincipal.TipoContaConjunta == 1) {
                    this.Titular = true;
                }
                if (this.dadosBancariosContaPrincipal.TipoContaConjunta == 2) {
                    this.Cotitular = true;
                }
            } else {
                // PJ/FI: objetos
                this.dadosBancariosContaPrincipal = this.infoBancariosPorTipo.find(info => info.Principal) || this.dadosBancariosContaPrincipal;
                this.dadosBancariosContaAdicional = this.infoBancariosPorTipo.find(info => !info.Principal) || this.dadosBancariosContaAdicional;
            }
        }
    },
    mounted() {
        this.validarFormulario(false);
    },
    watch: {
        Titular() {
            if (this.Titular) {
                this.dadosBancariosContaPrincipal.TipoContaConjunta = 1;
                this.Cotitular = false;
            }
        },
        Cotitular() {
            if (this.Cotitular) {
                this.dadosBancariosContaPrincipal.TipoContaConjunta = 2;
                this.Titular = false;
            }
        },
        infoBancariosPorTipo() {
            if (this.infoBancariosPorTipo.length > 0) {
                if (this.configTipo.estruturaDados === 'array') {
                    const contaPrincipal = this.infoBancariosPorTipo.find(conta => conta.Principal === true);
                    if (contaPrincipal) {
                        this.dadosBancariosContaPrincipal = contaPrincipal;
                        this.contas = this.infoBancariosPorTipo.filter(c => c.Principal === false);
                    }
                    if (this.dadosBancariosContaPrincipal.TipoContaConjunta == 1) {
                        this.Titular = true;
                    }
                    if (this.dadosBancariosContaPrincipal.TipoContaConjunta == 2) {
                        this.Cotitular = true;
                    }
                } else {
                    this.dadosBancariosContaPrincipal = this.infoBancariosPorTipo.find(info => info.Principal) || this.dadosBancariosContaPrincipal;
                    this.dadosBancariosContaAdicional = this.infoBancariosPorTipo.find(info => !info.Principal) || this.dadosBancariosContaAdicional;
                }
            }
            this.validarFormulario(false);
        }
    },
    methods: {
        initContaPrincipal() {
            const base = {
                Guid: '',
                NomeBanco: '',
                Agencia: '',
                ContaCorrente: '',
                Principal: true
            };

            if (this.configTipo.nomesCampos.agenciaDigito === 'AgenciaDigito') {
                base.AgenciaDigito = '';
                base.ContaCorrenteDigito = '';
            } else {
                base.DigitoAgencia = '';
                base.DigitoContaCorrente = '';
            }

            if (this.configTipo.temTipoConta) {
                base.TipoConta = 'Conta Corrente';
            }

            if (this.configTipo.contaConjunta) {
                base.ContaConjunta = false;
                base.TipoContaConjunta = 0;
                base.NomeCompleto = '';
                base.CpfContaConjunta = '';
            }

            return base;
        },

        initContaAdicional() {
            const base = {
                Guid: '',
                NomeBanco: '',
                Agencia: '',
                ContaCorrente: '',
                Principal: false
            };

            if (this.configTipo.nomesCampos.agenciaDigito === 'AgenciaDigito') {
                base.AgenciaDigito = '';
                base.ContaCorrenteDigito = '';
            } else {
                base.DigitoAgencia = '';
                base.DigitoContaCorrente = '';
            }

            return base;
        },

        addContaBancaria() {
            const novaConta = {
                Guid: '',
                NomeBanco: '',
                Agencia: '',
                AgenciaDigito: '',
                ContaCorrente: '',
                ContaCorrenteDigito: '',
                Principal: false,
                ContaConjunta: false,
                TipoContaConjunta: 0,
                TipoConta: 'Conta Corrente',
                NomeCompleto: '',
                CpfContaConjunta: ''
            };
            this.contas.push(novaConta);
        },

        updateTipoContaConjunta(param, index, event) {
            if (param == 'titular') {
                this.contas[index].TipoContaConjunta = event.target.checked ? 1 : 2;
            } else if (param == 'cotitular') {
                this.contas[index].TipoContaConjunta = event.target.checked ? 2 : 1;
            }
            this.salvarAlteracoesLocalmente();
        },

        validarFormulario(submeter) {
            // Guard: se dados bancários não foram inicializados ainda, não pode validar
            if (!this.dadosBancariosContaPrincipal || Object.keys(this.dadosBancariosContaPrincipal).length === 0) {
                return false;
            }

            this.permitirAvancar = true;
            var nomeDoCampo = '';
            
            this.camposObrigatorios = {
                erroContaCorrenteDigito: false,
                erroContaCorrente: false,
                erroAgencia: false,
                erroBanco: false,
                erroNomeBancoAdicional: false,
                erroAgenciaAdicional: false,
                erroContaCorrenteAdicional: false,
                erroDigitoContaCorrenteAdicional: false
            };
            
            // Validar conta principal
            if (!this.dadosBancariosContaPrincipal.NomeBanco) {
                if (submeter && this.permitirAvancar) {
                    this.camposObrigatorios.erroBanco = true;
                    nomeDoCampo = 'Banco';
                }
                this.permitirAvancar = false;
            }
            if (!this.dadosBancariosContaPrincipal.Agencia) {
                if (submeter && this.permitirAvancar) {
                    this.camposObrigatorios.erroAgencia = true;
                    nomeDoCampo = 'Agência';
                }
                this.permitirAvancar = false;
            }
            if (!this.dadosBancariosContaPrincipal.ContaCorrente) {
                if (submeter && this.permitirAvancar) {
                    this.camposObrigatorios.erroContaCorrente = true;
                    nomeDoCampo = 'Conta';
                }
                this.permitirAvancar = false;
            }
            
            const digitoCampo = this.configTipo.nomesCampos.contaDigito;
            if (!this.dadosBancariosContaPrincipal[digitoCampo]) {
                if (submeter && this.permitirAvancar) {
                    this.camposObrigatorios.erroContaCorrenteDigito = true;
                    nomeDoCampo = 'Dígito da Conta Corrente';
                }
                this.permitirAvancar = false;
            }
            
            // Validar contas adicionais PF
            if (this.configTipo.multiplasContas) {
                this.contas.forEach((c, index) => {
                    if (!c.NomeBanco) {
                        if (submeter && this.permitirAvancar) {
                            nomeDoCampo = 'Banco da conta adicional ' + (index + 1);
                        }
                        this.permitirAvancar = false;
                    }
                    if (!c.Agencia) {
                        if (submeter && this.permitirAvancar) {
                            nomeDoCampo = 'Agência da conta adicional ' + (index + 1);
                        }
                        this.permitirAvancar = false;
                    }
                    if (!c.ContaCorrente) {
                        if (submeter && this.permitirAvancar) {
                            nomeDoCampo = 'Número da conta adicional ' + (index + 1);
                        }
                        this.permitirAvancar = false;
                    }
                    if (!c.ContaCorrenteDigito) {
                        if (submeter && this.permitirAvancar) {
                            nomeDoCampo = 'Dígito da conta adicional ' + (index + 1);
                        }
                        this.permitirAvancar = false;
                    }
                });
            }
            
            // Validar conta adicional PJ/FI (só se algum campo preenchido)
            if (this.configTipo.contaAdicionalFixa) {
                const adicionalPreenchida = this.dadosBancariosContaAdicional.NomeBanco || 
                    this.dadosBancariosContaAdicional.Agencia || 
                    this.dadosBancariosContaAdicional.ContaCorrente ||
                    this.dadosBancariosContaAdicional[digitoCampo];
                    
                if (adicionalPreenchida) {
                    if (!this.dadosBancariosContaAdicional.NomeBanco) {
                        if (submeter && this.permitirAvancar) {
                            this.camposObrigatorios.erroNomeBancoAdicional = true;
                            nomeDoCampo = 'Banco da conta adicional';
                        }
                        this.permitirAvancar = false;
                    }
                    if (!this.dadosBancariosContaAdicional.Agencia) {
                        if (submeter && this.permitirAvancar) {
                            this.camposObrigatorios.erroAgenciaAdicional = true;
                            nomeDoCampo = 'Agência da conta adicional';
                        }
                        this.permitirAvancar = false;
                    }
                    if (!this.dadosBancariosContaAdicional.ContaCorrente) {
                        if (submeter && this.permitirAvancar) {
                            this.camposObrigatorios.erroContaCorrenteAdicional = true;
                            nomeDoCampo = 'Número da conta adicional';
                        }
                        this.permitirAvancar = false;
                    }
                    if (!this.dadosBancariosContaAdicional[digitoCampo]) {
                        if (submeter && this.permitirAvancar) {
                            this.camposObrigatorios.erroDigitoContaCorrenteAdicional = true;
                            nomeDoCampo = 'Dígito da conta adicional';
                        }
                        this.permitirAvancar = false;
                    }
                }
            }
            
            if (submeter && nomeDoCampo != '') {
                this.modalAlerta = { mostrar: true, tipo: 'warning', titulo: 'Atenção: Campo obrigatório', mensagem: `O campo ${nomeDoCampo} não foi informado, preencha a informação para avançar.` };
            }
            
            return this.permitirAvancar;
        },

        proximaEtapa() {
            if (this.validarFormulario(true)) {
                this.$store.commit('SET_ETAPA_CADASTRO', this.configTipo.proximaEtapa);
                this.$store.commit('SET_SALVAR_INFO_DES_NOTIFICACAO', true);
                this.salvarInformacoes();
            }
        },

        salvarInformacoes() {
            if (this.tipoCliente === 'Pessoa Física') {
                this.$store.commit('SET_PF_SALVAR_INFO', true);
            } else if (this.tipoCliente === 'Pessoa Jurídica') {
                this.$store.commit('SET_PJ_SALVAR_INFO', true);
            } else if (this.tipoCliente === 'Fundos') {
                this.$store.commit('SET_FI_SALVAR_INFO', true);
            }
        },

        salvarAlteracoesLocalmente() {
            if (this.configTipo.estruturaDados === 'array') {
                // PF: salva array com todas as contas
                let todasContas = [];
                
                if (this.dadosBancariosContaPrincipal) {
                    if (this.dadosBancariosContaPrincipal.ContaConjunta != true) {
                        this.dadosBancariosContaPrincipal.NomeCompleto = '';
                        this.dadosBancariosContaPrincipal.CpfContaConjunta = '';
                        this.dadosBancariosContaPrincipal.TipoContaConjunta = '0';
                    }
                    this.dadosBancariosContaPrincipal.Principal = true;
                    todasContas.push(this.dadosBancariosContaPrincipal);
                }
                
                if (this.contas && this.contas.length > 0) {
                    const contasAdicionais = this.contas.filter(conta => conta.Principal == false);
                    contasAdicionais.forEach(c => {
                        if (c.ContaConjunta != true) {
                            c.NomeCompleto = '';
                            c.CpfContaConjunta = '';
                            c.TipoContaConjunta = '0';
                        }
                        c.Principal = false;
                        todasContas.push(c);
                    });
                }
                
                this.$store.commit(this.configTipo.storeMutation, todasContas);
            } else {
                // PJ/FI: salva objetos separados
                this.$store.commit(this.configTipo.storeMutation, this.dadosBancariosContaPrincipal);
            }
            
            this.validarFormulario(false);
        },

        salvarAlteracoesLocalmenteAdicional() {
            if (this.configTipo.storeMutationAdicional) {
                this.$store.commit(this.configTipo.storeMutationAdicional, this.dadosBancariosContaAdicional);
            }
            this.validarFormulario(false);
        },

        async excluirContaBancaria(index) {
            if (!this.configTipo.apiExclusao || this.contas[index].Guid == '') {
                this.contas.splice(index, 1);
                this.salvarAlteracoesLocalmente();
                return;
            }
            
            // PF: chama API de exclusão
            await api.get(`PessoaFisica/dadosBancarios/excluir?guid=${this.contas[index].Guid}`)
                .then((retorno) => {
                    if (retorno.status == 200) {
                        this.$swal({
                            icon: 'success',
                            title: 'Exclusão realizada com sucesso!',
                            text: 'Dados informados foram excluídos com sucesso.',
                        });
                        this.contas.splice(index, 1);
                        this.salvarAlteracoesLocalmente();
                    }
                })
                .catch((error) => {
                    this.$swal({
                        icon: 'error',
                        title: 'Dados informados inválidos.',
                        text: `${error.response.data.data[0]}`,
                    });
                });
        }
    }
};
</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap');
</style>
